<!--
  * @Author: jh 1758579481@qq.com
  * @Date: 2021/2/25
-->
<template>
  <div class="container">
    <div class="van-tree-select__content" v-if="answerList.length>0">
      <div class="van-ellipsis van-tree-select__item" style="border-bottom: 1px #f7f8fa solid;" v-for="(item,index) in answerList" :key="index" @click="toDetails(item)">
        {{item.name+' '+item.createtime}}
        <i class="el-icon-arrow-right van-tree-select__selected" style="font-weight: 700;color: #8a8a8a"></i>
      </div>
    </div>
    <div class="noCard" v-if="!answerList.length>0">
      <div class="noCard-img">
        <img src="static/img/noCard.png"/>
      </div>
      <div class="noCard-text">暂无数据</div>
    </div>
  </div>
</template>

<script>
  import {gethisCrownresult} from '../../api/index'
  export default {
    name: "answerList",
    data() {
      return {
        answerList:[]
      }
    },
    created() {
      //修改标题
      document.title = '新冠问卷答案列表'
      this.gethisCrownresult()
    },
    methods: {
      gethisCrownresult(){
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        gethisCrownresult({
          strOpenid:this.$storage.get('openid')
        }).then(res=>{
          loading.close()
          this.answerList = res.Data
        })
      },
      toDetails(item){
        this.$router.push({path:'/answerDetails',query:{time:item.createtime,idCard:item.idCard}})
      }
    }
  }
</script>

<style scoped>
  @import "../../../static/css/vant.css";
  .container{
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    font-size: .32rem;
  }
  .noCard{
    width: 7.5rem;
    height: 3.5rem;
    padding: 2rem 0 4rem 0;
    background-color: #ffffff;
  }
  .noCard .noCard-img{
    width: 2.6rem;
    height: 2.6rem;
    margin: 0 auto;
  }
  .noCard .noCard-img img{
    width: 100%;
    height: 100%;
  }
  .noCard .noCard-text{
    margin-top: .3rem;
    font-size: .32rem;
    line-height: .32rem;
    width: 100%;
    height: .32rem;
    text-align: center;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/answerList.vue